// extracted by mini-css-extract-plugin
export default {"wrapper":"AdvertisementCarPropsBlock_wrapper__CvCsF","rate_mark":"AdvertisementCarPropsBlock_rate_mark__kt35j","shimmer":"AdvertisementCarPropsBlock_shimmer__NVWsd"};